import { useMutation } from '@tanstack/react-query';

import { resendVerificationEmail } from '@/services/api/requests/user';
import { TCustomAxiosError } from '@/services/api';
import useToast from '../useToast';

const useResendVerificationEmail = (onSuccessCallback?: (alreadyVerified: boolean) => void) => {
  const toast = useToast();

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: async () => {
      return resendVerificationEmail();
    },
    onSuccess: (data) => {
      const alreadyVerified = data?.message?.toLowerCase().includes('already verified') ?? false;

      toast({
        status: 'success',
        title: alreadyVerified ? 'Email already verified' : 'Verification email sent',
        description:
          data?.message ?? 'If your email is not yet verified, a new verification email is on its way.',
      });

      onSuccessCallback?.(alreadyVerified);
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          status: 'error',
          title: 'Could not resend verification email',
          description: error?.errors?.[0]?.message,
        },
        error,
      );
    },
  });

  return { mutate, isPending, isError, isSuccess };
};

export { useResendVerificationEmail };
